// extracted by mini-css-extract-plugin
module.exports = {"content":"PaymentMethodsPage_content__FmbNv","mobileTopbar":"PaymentMethodsPage_mobileTopbar__1Ahb2","title":"PaymentMethodsPage_title__VPmUw"};